import React from 'react'

const Change = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/change',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <g
        stroke={primaryColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.2'
      >
        <path d='M2.5 6l5-5h9c.518 0 1 .52 1 1v16c0 .48-.482 1-1 1h-13c-.518 0-1-.52-1-1V6z' />
        <path d='M2.5 6h5V1z' />
      </g>
      <path
        d='M5 9h10'
        stroke={primaryColor}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g stroke={secondaryColor}>
        <path d='M13.031 16v.317a.607.607 0 0 1-.605.605.607.607 0 0 1-.605-.605V16' />
        <path
          d='M10.706 14.817h-.173c-.293 0-.533.272-.533.605 0 .333.24.606.533.606h3.786c.293 0 .533-.273.533-.606 0-.333-.24-.605-.533-.605h-.173v-1.113c0-1.079-.77-1.953-1.72-1.953s-1.72.874-1.72 1.953v1.113z'
          strokeLinejoin='round'
        />
      </g>
      <path
        d='M10 6h5M5 12h3'
        stroke={primaryColor}
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
)

export default Change
